
import { FIREARM_ASSIGNABLE_PERSON_METADATA } from './firearm-assignable-person.metadata';
import { FirearmAssignablePersonBase } from './firearm-assignable-person.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface FirearmAssignablePerson extends FirearmAssignablePersonBase {
}

export interface FirearmAssignablePersonTransient { }

export class FirearmAssignablePerson extends CrudEntity<FirearmAssignablePerson, string, FirearmAssignablePersonTransient> implements FirearmAssignablePersonTransient {
  constructor(source?: Partial<FirearmAssignablePerson>, options?: CrudEntityConstructionOptions<FirearmAssignablePerson, string, FirearmAssignablePersonTransient>) {
    super(FIREARM_ASSIGNABLE_PERSON_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





